import { render, staticRenderFns } from "./OsAntesDiscEditorValidator.vue?vue&type=template&id=3ce03aae&scoped=true"
import script from "./OsAntesDiscEditorValidator.vue?vue&type=script&lang=ts"
export * from "./OsAntesDiscEditorValidator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce03aae",
  null
  
)

export default component.exports